import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
import { AchatService } from '../../../../services/achat/achat.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-cmd-fournisseur',
    templateUrl: './cmd-fournisseur.component.html',
    styleUrls: ['./cmd-fournisseur.component.scss']
})
export class CmdFournisseurComponent implements OnInit, OnDestroy {
    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'brouillon', 'valide', 'cree', 'annule'];
    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;
    private dataSub?: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private achatService: AchatService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        this.dataSub = this.achatService.commandeFournisseurTableData$.subscribe(() => {
            setTimeout(() => this.cdr.detectChanges(), 0);
        });
        this.headerService.setConfig({
            title: 'Commande fournisseurs',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this.dataSub?.unsubscribe();
    }

    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        const mappedStatus = this.mapPathToStatus(status);
        this.achatService.loadByTypeAndStatus('commande-fournisseur', mappedStatus);
        this.router.navigate([`/achat/commande-fournisseur/${status.toLowerCase()}`]);
    }

    private mapPathToStatus(path: string): string {
        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            brouillon: 'Brouillon',
            valide: 'Valide',
            cree: 'Crée',
            annule: 'Annulé'
        };
        return statusMap[path.toLowerCase()] || 'Tous';
    }

    getStatusCount(status: string): number {
        return this.achatService.getCommandeFournisseurStatusCount(status);
    }

    private exportToCSV(): void {
        const data = this.achatService.getCommandeFournisseurTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];
        const rows = data.map(item => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.matricule || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'commande-fournisseur.csv');
    }
}
